import { StyleSheet } from "react-native"
import { baseColors } from "@Constants/baseStyles"

const styles = StyleSheet.create({
    container: { paddingHorizontal: 0, paddingTop: 0, backgroundColor: baseColors.white },
    header: { backgroundColor: baseColors.green.primary, paddingHorizontal: 10, paddingVertical: 25 },
    content: {
        flex: 1,
        backgroundColor: "white",
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        marginTop: -5,
        paddingHorizontal: 12,
        paddingTop: 0
    },
    results: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: 30
    },
    resultLabel: { backgroundColor: "white", padding: 20, borderRadius: 30 },
    chartContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        marginTop: 15,
        marginBottom: 30
    },
    loading: {
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginVertical: "50%"
    }
})

export default styles
